import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteInvoiceRequest {
  invoiceIds?: any[];
}

const useDeleteInvoicesApi = () => {
  const call = useCallback(async ({ invoiceIds }: DeleteInvoiceRequest = {}) => {
    try {
      const res = await axiosInstance.post(`/Invoice/Delete`, invoiceIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { deleteInvoices: execute, deletedInvoicesLoading: isLoading };
};

export default useDeleteInvoicesApi;
